// DevHub UI kit — loading state block.
//
// The centered "Loading…" placeholder every section re-invents. Optional message;
// default is i18n'd.
import { useTranslationRef } from '@backstage/core-plugin-api/alpha';
import { kitMessages } from '../../../i18n/kit';
import './states.css';

export interface LoadingStateProps {
  /** Override the default "Loading…" message. */
  message?: string;
}

export const LoadingState = ({ message }: LoadingStateProps) => {
  const { t } = useTranslationRef(kitMessages);
  return (
    <div className="devhub-state devhub-state--loading">
      <odx-loading-spinner />
      <p className="devhub-state__message">{message ?? t('states.loading')}</p>
    </div>
  );
};
